import './Contact.css' 
import logo from '../../assets/logo.png'
import wsp from '../../assets/wsp.svg'
import ig from '../../assets/ig.svg'

function Contact() {
    return (
        <div className='contact-card'>
            <div className='sep'></div>
            <div>
                <a href='https://wa.me/56942933404' target='_blank' rel='noopener noreferrer'><img src={wsp} alt='whatsapp' className='icon'/></a>
                <a href='https://www.instagram.com/' target='_blank' rel='noopener noreferrer'><img src={ig} alt='instagram' className='icon'/></a>
            </div>
            <p className='content'>+569 4293 3404</p>
            <p className='content'>proyectos@constructorafqp.cl</p>
            <div className='division'>
                <p className='content'>#arquitectura</p>
                <p className='content'>#diseño</p>
                <p className='content'>#construcción</p>
            </div>
            <img className='logo' src={ logo } alt='Logo'></img>
        </div>
    )
}

export default Contact